import { atom } from "recoil";
import { alertDefault } from "src/constant/common";

export const alertState = atom({
  key: "alertState",
  default: alertDefault,
});

export const navigationPromptState = atom({
  key: "navigationPromptState",
  default: false,
});

export const resetFormPromptState = atom({
  key: "resetFormPromptState",
  default: false,
});

export const dataJson = atom({
  key: "getDataJsonState",
  default: null,
});

export const uploadingJsonFile = atom({
  key: "uploadingJsonFileState",
  default: false,
});
export const uploadingFile = atom({
  key: "uploadingFileState",
  default: false,
});
export const projectResourcesState = atom({
  key: "projectResourcesState",
  default: [],
});

export const projectListState = atom({
  key: "projectListState",
  default: [],
});

export const projectRoleState = atom({
  key: "projectRoleState",
  default: null,
});
